/* eslint-disable */


import { blue, grey } from '@material-ui/core/colors';
import merge from 'lodash/merge';

/**
 * Create dark theme styles for `<Calendar />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The dark theme `<Calendar />` styles
 */
const darkThemeStyles = ({ theme }) => ({
  [`@global`]: {
    [`.react-calendar`]: {
      background: `unset`,
      color: theme.palette.common.white,
    },
    [`.react-calendar__navigation`]: {
      [`& button`]: {
        color: theme.palette.common.white,
      },
      [`& button:enabled:hover, & button:enabled:focus`]: {
        backgroundColor: theme.palette.action.active,
        color: theme.palette.common.white,
      },
      [`& button[disabled]`]: {
        backgroundColor: theme.palette.action.disabled,
      },
    },
    [`.react-calendar__year-view .react-calendar__tile, .react-calendar__decade-view__years__year`]: {
      color: `unset`,
    },
    [`button.react-calendar__tile`]: {
      [`&.react-calendar__month-view__days__day`]: {
        color: `inherit`,
      },
      [`&:disabled`]: {
        backgroundColor: theme.palette.action.disabled,
        color: grey[600],
      },
      [`&:enabled:hover, &:enabled:focus`]: {
        backgroundColor: theme.palette.action.active,
        color: theme.palette.common.white,
      },
    },
  },
});

/**
 * Create default theme styles for `<Calendar />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The default theme `<Calendar />` styles
 */
const defaultCalendarStyles = ({ theme }) => ({
  [`@global`]: {
    [`.react-calendar`]: {
      [`& button`]: {
        marginBottom: theme.spacing(1) / 4,
        marginTop: theme.spacing(1) / 4,
      },
      fontFamily: `unset`,
    },
    [`.react-calendar__month-view__days__day`]: {
      [`&.react-calendar__tile--hasActive`]: {
        [`&:enabled:hover, &:enabled:focus`]: {
          backgroundColor: blue[300],
        },
        backgroundColor: blue[500],
      },
      [`&.react-calendar__tile--now`]: {
        [`&:enabled:hover, &:enabled:focus`]: {
          backgroundColor: blue[300],
        },
        backgroundColor: blue[700],
        color: theme.palette.common.white,
      },
    },
    [`.react-calendar__navigation__label`]: {
      fontSize: `unset`,
    },
    [`.react-calendar__tile--active`]: {
      backgroundColor: blue[500],
      color: `unset`,
    },
    [`button.react-calendar__tile`]: {
      [`&:disabled`]: {
        backgroundColor: `${grey[100]} !important`,
        color: grey[300],
      },
    },
  },
});

/**
 * Create styles for `<Calendar />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<Calendar />` styles
 */
const calendarStyles = ({ isDark, theme }) => ({
  root: {
    border: `0 !important`,
    paddingBottom: theme.spacing(1) / 4,
  },
  ...merge({}, defaultCalendarStyles({ theme }), isDark() && darkThemeStyles({ theme })),
});

export default calendarStyles;
